import React, { useContext } from "react";
import Styles from "./OurValues.module.scss";
import ResponsiveContainer from "@vahak/core/dist/components/responsive-container/ResponsiveContainer";
import { AppContext } from "@vahak/core/dist/app-context";

const OurValues = () => {
    const { isMobile } = useContext(AppContext);
    return (
        <>
            <div className={Styles.ourValuesHeading}>
                <h2>
                    We are equal parts{" "}
                    <span data-hover="fun and responsible!" className={isMobile ? "" : "indaiText"}>
                        fun and responsible!
                    </span>{" "}
                    At Vahak, all our people believe in
                </h2>
            </div>
            <div className={Styles.valuesRow}>
                <ResponsiveContainer>
                    <div className={Styles.valuesCard}>
                        <div className={Styles.textBox}>
                            <h4>Taking Ownership</h4>
                            <p>Everyone owns the product and the dream!</p>
                        </div>
                    </div>
                    <div className={Styles.valuesCard}>
                        <div className={Styles.textBox}>
                            <h4>Collaborating on the job</h4>
                            <p>Our Team works hand-in-hand</p>
                        </div>
                    </div>
                    <div className={Styles.valuesCard}>
                        <div className={Styles.textBox}>
                            <h4>Striving for Excellence</h4>
                            <p>We want to make our product the best.</p>
                        </div>
                    </div>
                    <div className={Styles.valuesCard}>
                        <div className={Styles.textBox}>
                            <h4>Thinking User-first</h4>
                            <p>Our decisions are always user-first</p>
                        </div>
                    </div>
                    <div className={Styles.valuesCard}>
                        <div className={Styles.textBox}>
                            <h4>Learning on-the-go</h4>
                            <p>We invest in our people and pride ourselves in their growth!</p>
                        </div>
                    </div>
                </ResponsiveContainer>
            </div>
        </>
    );
};

export default OurValues;
